import './ServicesCard.css';
import React from 'react';
import { Link } from 'react-router-dom';


function ServicesCard({title, image, description, link}) {
  const linkName = "/" + link;
  return (
    <section className="ServiceCard">
      <img className="card-img" src={image} alt=""/>
        <div>
        <h3>{title}</h3>
        <hr></hr>
        <p>{description}</p>
        <div className="LinkButton">
          <Link  to={linkName}><input type="submit" value="Read More"/></Link>
        </div>
        </div>
    </section>
    )
}

export default ServicesCard;
